import styles from "./PageLayout.module.css";
import { useTranslation } from "react-i18next";

export default function PageLayout({ children, title, titleKey }) {
    const { t } = useTranslation();
    const resolvedTitle = title ?? (titleKey ? t(titleKey) : "");
    return (
        <main className={styles.page}>
            <h1 className={styles.title}>{resolvedTitle}</h1>
            <div className={styles.content}>{children}</div>
        </main>
    );
}